import React, { createContext, useContext, useState, useEffect } from 'react';

export type AppType = "budget" | "breakdown" | null;

interface AppTypeContextType {
  appType: AppType;
  setAppType: (type: AppType) => void;
}

const AppTypeContext = createContext<AppTypeContextType | undefined>(undefined);

export const useAppTypeContext = () => {
  const context = useContext(AppTypeContext);
  if (context === undefined) {
    throw new Error('useAppTypeContext must be used within an AppTypeProvider');
  }
  return context;
};

export const AppTypeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [appType, setAppTypeState] = useState<AppType>(() => {
    const saved = localStorage.getItem('appType');
    if (saved === 'budget' || saved === 'breakdown') {
      return saved;
    }
    if (saved === 'breakdown') {
      try {
        localStorage.setItem('appType', 'breakdown');
      } catch {
        /* ignore */
      }
      return 'breakdown';
    }
    return null;
  });

  // 持久化appType到localStorage
  useEffect(() => {
    if (appType) {
      localStorage.setItem('appType', appType);
    } else {
      localStorage.removeItem('appType');
    }
  }, [appType]);

  const setAppType = (type: AppType) => {
    setAppTypeState(type);
  };

  const value: AppTypeContextType = {
    appType,
    setAppType,
  };

  return <AppTypeContext.Provider value={value}>{children}</AppTypeContext.Provider>;
};
